import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const FilterDropdownRow = styled<any, any>(
    'div',
    'filterDropdownRow',
    'filterItemDropdown'
)`
    ${propStyles};
`;

export default FilterDropdownRow;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/FilterDropdownRow.tsx